import { FormControlLabel, Switch, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React from "react";
import { useState } from "react";
const Blueswitch = withStyles({
    switchBase: {
      color: "blue",
      '&$checked': {
        color: "blue",
      },
      '&$checked + $track': {
        backgroundColor: "blue",
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const Blackswitch = withStyles({
    switchBase: {
      color: "black",
      '&$checked': {
        color: "black",
      },
      '&$checked + $track': {
        backgroundColor: "black",
      },
    },
    checked: {},
    track: {},
  })(Switch);


  const Orangeswitch = withStyles({
    switchBase: {
      color: "orange",
      '&$checked': {
        color: "orange",
      },
      '&$checked + $track': {
        backgroundColor: "orange",
      },
    },
    checked: {},
    track: {},
  })(Switch);
export default function ThermocouplesConfig (){
  
    const [checked, setChecked] = React.useState(true);

  const toggleChecked = (i) => {
    setChecked((prev) => !prev);
   
  };
  const [checked1, setChecked1] = React.useState(true);

  const toggleChecked1 = (i) => {
    setChecked1((prev) => !prev);
  };
  const [checked2, setChecked2] = React.useState(true);

  const toggleChecked2 = (i) => {
    setChecked2((prev) => !prev);
  };
  const [checked3, setChecked3] = React.useState(true);

  const toggleChecked3 = (i) => {
    setChecked3((prev) => !prev);
  };
  const [checked4, setChecked4] = React.useState(true);

  const toggleChecked4 = (i) => {
    setChecked4((prev) => !prev);
  };
  const [checked5, setChecked5] = React.useState(true);

  const toggleChecked5 = (i) => {
    setChecked5((prev) => !prev);
  };
  const [checked6, setChecked6] = React.useState(true);

  const toggleChecked6 = (i) => {
    setChecked6((prev) => !prev);
  };
  const [checked7, setChecked7] = React.useState(true);

  const toggleChecked7 = (i) => {
    setChecked7((prev) => !prev);
  };
  const [checked8, setChecked8] = React.useState(true);

  const toggleChecked8 = (i) => {
    setChecked8((prev) => !prev);
  };
  const [checked9, setChecked9] = React.useState(true);

  const toggleChecked9 = (i) => {
    setChecked9((prev) => !prev);
  };
  const [checked10, setChecked10] = React.useState(true);

  const toggleChecked10 = (i) => {
    setChecked10((prev) => !prev);
  };
  const [checked11, setChecked11] = React.useState(true);

  const toggleChecked11 = (i) => {
    setChecked11((prev) => !prev);
  };
  const [checked12, setChecked12] = React.useState(true);

  const toggleChecked12 = (i) => {
    setChecked12((prev) => !prev);
  };
  const [checked13, setChecked13] = React.useState(true);

  const toggleChecked13 = (i) => {
    setChecked13((prev) => !prev);
  };
  const [checked14, setChecked14] = React.useState(true);

  const toggleChecked14 = (i) => {
    setChecked14((prev) => !prev);
  };
  const [checked15, setChecked15] = React.useState(true);

  const toggleChecked15 = (i) => {
    setChecked15((prev) => !prev);
  };

  
    var [verif, setValue] =  useState(false);
    const onClick = () => setValue(!verif)
    if (verif)
  return(
     <div className="MyNewClass" style={{background:'white',border:'black'}}  >
      
     
      <button style={{position:'relative',top:10,right:-1400 }} className="stopwatch-btn stopwatch-btn-red" onClick={onClick}>hide configuration</button>
 
      <center><h4>ThermoCouples</h4></center>
      <div style={{display:'flex',justifyContent:'space-evenly'}}>
      <FormControlLabel
    control={<Blueswitch size="small" checked={checked} onChange={toggleChecked} />}
    label="Check All"
  />
    <FormControlLabel
    control={<Blueswitch size="small" checked={checked1} onChange={toggleChecked1} />}
    label="Coldest TC"
  />
    <FormControlLabel
    control={<Switch size="small" checked={checked2} onChange={toggleChecked2} />}
    label="Hottest TC"
  />
  <br/> <br/><br/><br/><br/>
  </div>
      <div style={{display:'flex',justifyContent:'space-evenly'}}>
           <FormControlLabel
    control={<Blueswitch size="small" checked={checked3} onChange={toggleChecked3} />}
    label="TC°1"
  />
   <FormControlLabel
    control={<Blueswitch size="small" checked={checked4} onChange={toggleChecked4} />}
    label="TC°2"
  />
   <FormControlLabel
    control={<Blueswitch size="small" checked={checked5} onChange={toggleChecked5} />}
    label="TC°3"
  />
   <FormControlLabel
    control={<Blueswitch size="small" checked={checked6} onChange={toggleChecked6} />}
    label="TC°4"
  />
   <FormControlLabel
    control={<Blueswitch size="small" checked={checked7} onChange={toggleChecked7} />}
    label="TC°5"
  />
  
  <FormControlLabel
    control={<Blueswitch size="small" checked={checked8} onChange={toggleChecked8} />}
    label="TC°6"
  />    
          </div>
          <br/>
          <div style={{display:'flex',justifyContent:'space-evenly'}}>
           <FormControlLabel
    control={<Orangeswitch size="small" checked={checked9} onChange={toggleChecked9} />}
    label="TC°7"
  />
   <FormControlLabel
    control={<Orangeswitch size="small" checked={checked10} onChange={toggleChecked10} />}
    label="TC°8" 
  />
   <FormControlLabel
    control={<Orangeswitch size="small" checked={checked11} onChange={toggleChecked11} />}
    label="TC°9"
  />
   <FormControlLabel
    control={<Orangeswitch size="small" checked={checked12} onChange={toggleChecked12} />}
    label="TC°10"
  />
   <FormControlLabel
    control={<Orangeswitch size="small" checked={checked13} onChange={toggleChecked13} />}
    label="TC°11"
  />
  
  <FormControlLabel
    control={<Orangeswitch size="small" checked={checked14} onChange={toggleChecked14} />}
    label="TC°12"
  />    
          </div>

     
      <br/><br/>

 <center><h4>Vacuums</h4></center>
<div style={{display:'flex',justifyContent:'space-evenly'}}>
           <FormControlLabel
    control={<Blackswitch size="small" checked={checked15} onChange={toggleChecked15} />}
    label="V°1"
  />
   <FormControlLabel
    control={<Blackswitch size="small" checked={checked} onChange={toggleChecked} />}
    label="V°2"
  />
  <br/><br/><br/>
  </div>
  </div>)
  else 
  return(
    <div  className="stopwatch" >
<button className="stopwatch-btn stopwatch-btn-blu" onClick={onClick} > ThermoCouple Config</button>
</div>
  )
}